import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Feather, Edit3, Loader2 } from "lucide-react";

export const FounderText = ({ canEdit }) => {
  const { API } = useAuth();
  const [doc, setDoc] = useState(null);
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState("");
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => axios.get(`${API}/history/founder-text`).then(r => setDoc(r.data)), [API]);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    setBusy(true);
    try { await axios.put(`${API}/history/founder-text`, { value: draft }); toast.success("Texte fondateur enregistré"); setOpen(false); load(); }
    catch (err) { toast.error(err.response?.data?.detail || "Erreur"); } finally { setBusy(false); }
  };
  if (!doc) return null;

  return (
    <section className="rounded-2xl bg-[#261911] text-[#FAF7F2] p-6 sm:p-10 mb-10 relative overflow-hidden" data-testid="founder-text">
      <Feather className="absolute -right-6 -top-6 w-40 h-40 text-[#993D22] opacity-20" />
      <div className="label-uppercase text-[#D9822B] mb-3">Texte fondateur</div>
      <h2 className="font-serif-heritage text-3xl sm:text-4xl leading-tight mb-5 max-w-3xl">{doc.title}</h2>
      {doc.value ? (
        <div className="whitespace-pre-wrap leading-relaxed text-[#F0E6D8] max-w-3xl" data-testid="founder-text-body">{doc.value}</div>
      ) : (
        <p className="italic text-[#C9B8A8]" data-testid="founder-text-empty">Le texte intégral sera ajouté par l'administration.</p>
      )}
      {canEdit && (
        <Button size="sm" variant="outline" className="mt-6 border-[#D9822B] text-[#D9822B] bg-transparent hover:bg-[#D9822B] hover:text-[#261911]"
          onClick={() => { setDraft(doc.value || ""); setOpen(true); }} data-testid="edit-founder-text-btn">
          <Edit3 className="w-4 h-4 mr-2" /> {doc.value ? "Modifier le texte" : "Saisir le texte"}
        </Button>
      )}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#FAF7F2] max-w-3xl">
          <DialogHeader><DialogTitle className="font-serif-heritage text-2xl text-[#261911]">{doc.title}</DialogTitle></DialogHeader>
          <p className="text-xs text-[#6E5B4F]">Collez le texte intégral. Les versions précédentes sont conservées.</p>
          <Textarea rows={16} value={draft} onChange={e => setDraft(e.target.value)} data-testid="founder-text-input" />
          <div className="flex justify-end gap-2">
            <Button variant="ghost" onClick={() => setOpen(false)}>Annuler</Button>
            <Button className="btn-terra" onClick={save} disabled={busy} data-testid="save-founder-text-btn">{busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Enregistrer</Button>
          </div>
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default FounderText;
